<div class="flex flex-col gap-4 px-4">
  @if (resolvedType() === "create") {
    <h1 class="text-primary text-2xl font-bold" i18n="@@pharmacyInformation">Pharmacy Information</h1>
  }
  @if (resolvedType() === "edit") {
    <h1 class="text-primary text-2xl font-bold" i18n="@@editPharmacyInformation">Edit Request</h1>
  }
  <app-new-request-form
    [type]="resolvedType()"
    [pharmacyData]="resolvedType() === 'edit' ? pharmacyData() : undefined" />
</div>
